import React, { useEffect } from 'react';
import Konva from 'konva';
import { Group, Circle, Rect } from 'react-konva';
// import { setProjectState } from '@starflow/app/store';

Konva._fixTextRendering = true;

export const Shape = React.memo(({ element, editingElementId }) => {
  const { data, width, height, x, y, scaleX, scaleY } = element;
  // const isEditing = editingElementId === element.id;

  // useEffect(() => {
  //   console.log('zhl Shape', element);
  // }, []);

  // const handleEditText = () => {
  //   setProjectState({ editingElementId: element.id });
  // };

  return (
    <Group>
      {data.shape === 'square' && (
        <Rect
          role="element"
          roleType="shape_square"
          id={`${element.id}-square`}
          name={element.id}
          width={width}
          height={height}
          fill={data.backgroundColor}
        />
      )}
      {data.shape === 'circle' && (
        <Circle
          role="element"
          roleType="shape_circle"
          id={`${element.id}-circle`}
          name={element.id}
          // radius={parseInt(Math.max(width, height) / 2, 10)}
          width={width}
          height={height}
          x={width / 2}
          y={height / 2}
          fill={data.backgroundColor}
        />
      )}
    </Group>
  );
});
